import * as React from 'react';

const ShopCompass = props => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    stroke="none"
    strokeWidth={1}
    fill="#F25757"
    fillRule="evenodd"
    {...props}>
    <path
      d="M24,48 C10.745,48 0,37.255 0,24 C0,10.745 10.745,0 24,0 C37.255,0 48,10.745 48,24 C48,37.255 37.255,48 24,48 Z"
      opacity={0.200000003}
    />
    <path d="M36.102,10.193 L21.378,20.021 C20.845,20.376 20.388,20.834 20.033,21.367 L10.217,36.108 C9.896,36.589 9.959,37.23 10.368,37.639 C10.776,38.048 11.417,38.112 11.898,37.792 L26.622,27.964 C27.155,27.608 27.613,27.151 27.968,26.617 L37.784,11.877 C38.105,11.395 38.042,10.755 37.633,10.346 C37.224,9.937 36.584,9.873 36.102,10.193 L36.102,10.193 Z" />
    <path
      fill="#FFFFFF"
      d="M24,27 C22.343,27 21,25.657 21,24 C21,22.343 22.343,21 24,21 C25.657,21 27,22.343 27,24 C27,25.657 25.657,27 24,27 Z"
    />
  </svg>
);

export default ShopCompass;



// WEBPACK FOOTER //
// ./src/assets/images/icons/shop-compass.js